import React from 'react';
import type { SpineLaneStemData } from '../types';
import { useChatDagRuntime } from '../../../../contexts/ChatDagRuntimeContext';

// Source Spines SP-2/SP-3c — the dormant stem under a COLLAPSED source card. A
// short dashed vertical rail + terminus dot signalling "a spine is tucked here".
// SP-3c (Alan): now CLICKABLE to re-expand (both blueprint + artifact stems —
// this one shared component), mirroring the owning card's chevron. Reads runtime
// directly (like BlueprintNode); the rail stays visually thin (items-center on a
// widened hit area). Artifact stems (cardId 'tile-…') are emerald to belong to
// the green tile; blueprint stays amber.
export const SpineLaneStemNode: React.FC<{ data: SpineLaneStemData }> = ({ data }) => {
  const runtime = useChatDagRuntime();
  const isArtifact = data.cardId.startsWith('tile-');
  const rail = isArtifact
    ? 'border-emerald-500/60 dark:border-emerald-400/60'
    : 'border-amber-500/60 dark:border-amber-400/60';
  const dot = isArtifact
    ? 'bg-emerald-500/70 dark:bg-emerald-400/70'
    : 'bg-amber-500/70 dark:bg-amber-400/70';
  return (
    <div
      data-testid="spine-lane-stem"
      role="button"
      tabIndex={0}
      aria-label="Expand this artifact’s spine"
      title="Expand this spine"
      onClick={(e) => { e.stopPropagation(); runtime.toggleCardSpineExpansion(data.cardId); }}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); runtime.toggleCardSpineExpansion(data.cardId); } }}
      className={`nodrag nopan flex flex-col items-center cursor-pointer ${isArtifact ? 'hover:bg-emerald-50 dark:hover:bg-gray-700/40' : 'hover:bg-amber-50 dark:hover:bg-gray-700/40'}`}
      style={{ pointerEvents: 'auto', height: '100%' }}
    >
      <div className={`flex-1 w-0 border-l-2 border-dashed ${rail}`} />
      <span className={`block rounded-full ${dot}`} style={{ width: 4, height: 4 }} />
    </div>
  );
};

export default SpineLaneStemNode;
